import { Injectable } from '@angular/core';
import {  MsalService } from '@azure/msal-angular';
import { AuthHelperService } from '../auth-helper.service';

@Injectable({
  providedIn: 'root'
})
export class AuthService {
  userDetails:any;
  userRoles:any[];

  constructor(private msalService: MsalService,
    
    private authHelperService: AuthHelperService) { }

  getUserRoles() {
    this.userDetails = this.msalService.instance?.getActiveAccount()?.idTokenClaims;  
    return this.userDetails.roles;
  }

  getUserName() {
    return this.msalService.instance?.getActiveAccount()?.name;
  }

  getUserGDId() {
    return this.msalService.instance?.getActiveAccount()?.username;
  }

  logout() {
    this.authHelperService.logout();
  }
}
